export default class TableSelectionHandler {

  static NONE = 'none';
  static SINGLE = 'single';
  static MULTIPLE = 'multiple';

  constructor(type = TableSelectionHandler.SINGLE) {
    this.type = type;
    this.selectionStart = this.selectionEnd = 0;
  }

  static clearSelection() {
    return undefined;
  }

  static getNumberOfSelectedItems(selection = {}) {
    return Object.keys(selection).length;
  }

  static getSelectedItems(items = [], selection = {}) {
    return items.filter((item, index) => selection[item.id || index]);
  }

  handleSelectionEvent(items, index, selection = {}, e = {}) {
    let id = items[index].id || index;

    if (this.type !== TableSelectionHandler.NONE && index >= 0 && items.length > 0) {
      if (this.type === TableSelectionHandler.SINGLE || (!e.shiftKey && !e.ctrlKey && !e.metaKey)) {
        this.selectionStart = this.selectionEnd = index;
        selection = { // eslint-disable-line no-param-reassign
          [id]: true,
        };
      } else if (e.metaKey || e.ctrlKey) {
        selection = { ...selection }; // eslint-disable-line no-param-reassign
        if (selection[id]) {
          delete selection[id];
        } else {
          selection[id] = true;
        }
        this.selectionStart = this.selectionEnd = index;
      } else if (e.shiftKey) {
        const [start, end] = this.selectionStart > index ? [index, this.selectionStart] : [this.selectionStart, index];

        selection = { ...selection }; // eslint-disable-line no-param-reassign
        for (let i = start; i <= end; i++) {
          selection[items[i].id || i] = true;
        }
        this.selectionEnd = index;
      }
    }
    return selection;
  }

  static hasSelection(selection) {
    return selection && Object.keys(selection).length > 0;
  }

  static selectAll(items = []) {
    return items.reduce((acc, item) => {
      acc[item.id] = true;
      return acc;
    });
  }

}
